export const Fetch_Ticket = 'FETCHTICKET'
export const Add_Ticket = 'ADDTICKET'
export const Delete_Ticket = 'DELETETICKET'
export const Update_Ticket = 'UPDATETICKET' 
